import constants from '#packages/constants';
import type { EditorAPI } from '#packages/editorAPI';
import * as stateManagement from '#packages/stateManagement';
import type { CompRef } from '@wix/document-services-types';

const { findCurrentSlide } = stateManagement.boxSlideShow.selectors;
const { ACCESSIBILITY } = constants.COMP_META_DATA.CONTROLS;

function isRepeaterState(editorAPI: EditorAPI, comp: CompRef) {
  const currentSlide = findCurrentSlide(editorAPI.dsRead, comp);
  return editorAPI.components.is.repeater(currentSlide);
}

export default {
  selectedBeforeDescendants: (editorAPI: EditorAPI, comp: CompRef) =>
    isRepeaterState(editorAPI, comp),
  nestedBackgroundDesign: true,
  slidesContainer: true,
  focusable: true,
  exposesSlideAsInnerComponent: true,
  canContain: false,
  canContainByStructure: false,
  applyMetaDataToFirstChild: {
    selectable: false,
    focusable: false,
    selectedBeforeDescendants: false,
    slideContainer: true,
    controlledByParent: true,
  },
  delegateControlsToFirstChild: {
    override: [ACCESSIBILITY],
  },
  overridesWhenReferred: {
    gfpp: {
      disableMainActionsByLabelKey: [
        constants.STATE_BOX.GFPP.ACTIONS.LABELS.MANAGE_STATES,
      ],
    },
  },
};
